import React, { useState } from 'react'
import { Cookie } from '@mercadona/mo.library.web-services/cookies'
import { useTranslation } from 'react-i18next'

import { Input } from 'system-ui/input'
import { redirectToOldShop, redirectToShop } from 'utils/redirect'
import { DeliveryAreaClient } from 'app/delivery-area/client'
import {
  sendNotSupportedPostalCodeMetrics,
  sendSupportedPostalCodeMetrics,
} from 'app/delivery-area/metrics'
import { setDeliveryAreaCookie } from 'utils/cookies'
import { TranslationService } from 'services/translation'

import './PostalCodeForm.css'

const DELIVERY_COOKIE = process.env.REACT_APP_DELIVERY_COOKIE
const REGEXP_POSTAL_CODE = /^0[1-9][0-9]{3}|[1-4][0-9]{4}|5[0-2][0-9]{3}$/

const postalCodeValidation = {
  message: 'validation_errors.postal_code',
  type: 'error',
  ruleFails: (postalCode) =>
    !REGEXP_POSTAL_CODE.test(postalCode) || postalCode.length > 5,
}

const updateDeliveryInfo = (postalCode) => {
  const cookie = Cookie.get(DELIVERY_COOKIE)
  const deliveryInfo = { ...cookie, postalCode }

  setDeliveryAreaCookie(deliveryInfo)
}

const getDefaultPostalCodeValue = () => {
  const deliveryInfo = Cookie.get(DELIVERY_COOKIE)

  if (!deliveryInfo) return ''

  return deliveryInfo.postalCode
}

function PostalCodeForm() {
  const { t } = useTranslation()
  const defaultForm = getDefaultForm()
  const [form, updateForm] = useState(defaultForm)

  const updateAndValidateForm = (value) => {
    const validation = buildValidation(value)

    updateForm({
      postalCode: { value, validation },
      isValid: !validation,
    })
  }

  const submit = async (event) => {
    event.preventDefault()
    const postalCode = form.postalCode.value

    if (!postalCode) return

    if (!form.isValid) {
      updateAndValidateForm(postalCode)
      return
    }

    try {
      await DeliveryAreaClient.validatePostalCode(postalCode)
      sendSupportedPostalCodeMetrics()
      updateDeliveryInfo(postalCode)
      redirectToShop()
    } catch (error) {
      sendNotSupportedPostalCodeMetrics()
      const validLanguage = TranslationService.getTCLanguage()
      redirectToOldShop(validLanguage)
    }
  }

  const onChange = (event) => {
    updateAndValidateForm(event.target.value)
  }

  function buildValidation(value) {
    const isValid = !postalCodeValidation.ruleFails(value)

    if (!value || isValid) {
      return null
    }

    return {
      message: t(postalCodeValidation.message),
      type: postalCodeValidation.type,
    }
  }

  function getDefaultForm() {
    const value = getDefaultPostalCodeValue()
    const validation = buildValidation(value)

    return {
      postalCode: { value, validation },
      isValid: !validation,
    }
  }

  return (
    <form className="postal-code-form" onSubmit={submit}>
      <Input
        className="postal-code-form__input"
        value={form.postalCode.value}
        validation={form.postalCode.validation}
        onChange={onChange}
        maxLength="5"
        label={t('header_section.input.label')}
      />
      <input
        className="postal-code-form__button"
        type="submit"
        value={t('header_section.button')}
      />
    </form>
  )
}

export { PostalCodeForm }
